import React, { useState, useEffect } from 'react';
import { IoSend } from 'react-icons/io5';
import ThreeDotLoader from '../components/ThreeDotLoader';
import { toast } from 'react-toastify';
import Linkify from 'react-linkify';
import { deleteWithToken, getLocalStorage, getWithoutToken, getWithToken, postWithoutToken, postWithToken } from '../API/Api';
import SIDEBAR_BOX_IMG from '../assets/images/comniqAI/comniqai-smalllogo.svg';
import COMNIQ_LOGO from '../assets/images/comniqAI/comniq-logo-dark.svg';
import { BiTrash } from 'react-icons/bi';
import { MdOutlineAddBox, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import ScrollToBottom from './ScrollToBottom';
import CalendlyEmbed from './CalendlyEmbed';
import { formatText } from '../API/Constant';
import { CgClose } from 'react-icons/cg';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { X } from 'lucide-react';

const AIPreview = ({ openChatbox, setOpenChatbox }) => {
  const [chatData, setChatData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState('');
  const [apiTokenData, setApiTokenData] = useState('');
  const [widgetDetails, setWidgetDetails] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [hideLeadButtons, setHideLeadButtons] = useState(false);
  const [hideLeadClosingButtons, setHideLeadClosingButtons] = useState(false);
  const [companyDetails, setCompanyDetails] = useState('');
  const [customDisabled, setCustomDisabled] = useState(false);
  const [deleteConfirmPopup, setDeleteConfirmPopup] = useState(false);
  const [welBubblePopup, setWelBubblePopup] = useState(false);
  const [welcomeDetails, setWelcomeDetails] = useState({
    welcome_msg: null,
    lead_choice: null,
    lead_status: false,
    generate_lead_choice: null,
    create_lead_choice: null,
    is_calendar: false,
    lead_form: false,
    is_powered_by_visible: false,
  });

  const initialFormValue = {
    name: '',
    email: '',
    phone_number: '',
  };
  const [showForm, setShowForm] = useState(false);
  const [showCalendar, setShowCalendar] = useState({
    show: false,
    link: '',
  });
  const [formData, setFormData] = useState(initialFormValue);
  const [showFormButton, setShowFormButton] = useState(false);
  const [showRecommendation, setShowRecommendation] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLeadButtonHide, setIsLeadButtonHide] = useState(false);
  const [ip, setIp] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(true);
  const { name, email, phone_number } = formData;

  useEffect(() => {
    fetch('https://api.ipify.org/?format=json')
      .then((res) => res.json())
      .then((data) => setIp(data?.ip))
      .catch((err) => toast.error('Error fetching IP address'));
  }, []);

  useEffect(() => {
    let debounce = null;
    let token = getLocalStorage('apiToken');
    if (token) {
      if (debounce != null) {
        clearTimeout(debounce);
      }
      debounce = setTimeout(() => {
        setApiTokenData(JSON.parse(token));
        getCompanyDetails(JSON.parse(token));
        getWelcomeMsg(JSON.parse(token));
        getWidgetDetails(JSON.parse(token));
      }, 500);
    }
    return () => {
      clearTimeout(debounce);
    };
  }, [chatData]);

  useEffect(() => {
    setSessionId(generateRandomSessionId());
  }, []);

  useEffect(() => {
    if (widgetDetails?.buble_timer_count && widgetDetails?.buble_active_status) {
      if (widgetDetails.status && widgetDetails.buble_active_status) {
        if (!widgetDetails?.popup_status) {
          setTimeout(() => {
            setWelBubblePopup(true);
          }, widgetDetails?.buble_timer_count * 1000);
        }
      }
    } else {
      setWelBubblePopup(false);
    }
  }, [widgetDetails]);

  const generateRandomSessionId = () => {
    const numbers = '0123456789';
    const length = 8;
    let randomId = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * numbers.length);
      randomId += numbers.charAt(randomIndex);
    }
    return randomId;
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const getWidgetDetails = (token) => {
    getWithToken('Webchat_test_widgetAPI/', token)
      .then((response) => {
        if (response.status === 200) {
          setWidgetDetails(response?.data);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  const getWelcomeMsg = (token) => {
    getWithToken('wellcomeSmsApi/', token)
      .then((response) => {
        if (response.status === 200) {
          setWelcomeDetails({
            welcome_msg: response?.data?.welcome_msg,
            lead_choice: response?.data?.lead_choice,
            lead_status: response?.data?.status,
            generate_lead_choice: response?.data?.generate_lead_choice,
            create_lead_choice: response?.data?.create_lead_choice,
            is_calendar: response?.data?.is_calendar,
            lead_form: response?.data?.lead_form,
            is_powered_by_visible: response?.data?.is_powered_by_visible,
          });
        }
        if (response.status === 200) {
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };
  const getCompanyDetails = (token) => {
    getWithToken('company_base/', token)
      .then((response) => {
        if (response.status === 201) {
          setCompanyDetails(response?.data);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const getShowRecommendation = (id) => {
    getWithoutToken(`test_lead_answers_retrieve/${id}`)
      .then((response) => {
        if (response.status === 200) {
          setShowRecommendation(response?.data);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (values.trim().length > 0) {
      let newObj = { prmt: values };
      chatData.push(newObj);
      let body = {
        prompt: values,
        session_id: sessionId,
        ip_address: ip,
      };
      setValues('');
      setLoader(true);
      setIsButtonDisabled(true);
      setShowRecommendation(null);
      setShowCalendar({});
      chatPostApi(body);
    } else {
      toast.dismiss();
      toast.error('Message is blank.');
      setLoader(false);
    }
  };

  const chatPostApi = async (body) => {
    try {
      setCustomDisabled(true);
      setShowPrivacy(false);
      const response = await postWithToken(`test_conversion?conversation_type=${welcomeDetails?.lead_status ? 'leap' : 'general'}`, apiTokenData, body);

      if (response.status === 200) {
        const tempChatData = [...chatData];
        const { data } = response;
        data.forEach((element) => {
          let tempData = {
            choice: element,
            text: element.text,
            id: element.id,
          };

          if (!welcomeDetails?.lead_choice) {
            setHideLeadButtons(false);
          }

          if (tempData?.choice?.closing_chatbot === true) {
            setTimeout(() => {
              setOpenChatbox(false);
            }, 2000);
          }

          if (tempData?.choice?.closing_lead_choice !== undefined) {
            setHideLeadClosingButtons(false);
          } else {
            setCustomDisabled(true);
          }

          if (element?.lead_form) {
            setShowForm(true);
          }
          if (element?.calendar)
            setShowCalendar({
              show: true,
              link: element?.calendar,
            });

          if (element?.recommendation) {
            getShowRecommendation(element?.recommendation);
          }

          tempChatData.push(tempData);
        });

        setChatData(tempChatData);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error('An unexpected error occurred.');
    } finally {
      setCustomDisabled(false);
      setIsButtonDisabled(false);
      setLoader(false);
    }
  };

  const handleChoice = (e, Data) => {
    setHideLeadButtons(true);
    setHideLeadClosingButtons(true);
    setIsButtonDisabled(true);
    let newObj = { prmt: Data };
    chatData.push(newObj);
    let body = {
      prompt: Data,
      session_id: sessionId,
      ip_address: ip,
    };
    setLoader(true);
    setOpenChatbox(true);
    chatPostApi(body);
  };

  const hanldeClearData = () => {
    deleteWithToken('ChatGPTAPI_', apiTokenData)
      .then((response) => {
        if (response.status === 200) {
          setHideLeadButtons(false);
          setChatData([]);
          setShowForm(false);
          setShowRecommendation(null);
          setShowFormButton(false);
          setIsLeadButtonHide(false);
          setIsButtonDisabled(false);
          setDeleteConfirmPopup(false);
          setIsDropdownOpen(false);
          setShowPrivacy(true);
          setShowCalendar({});
          setSessionId(generateRandomSessionId());
          // toast.success(response?.message);
        } else if (response.code === 'token_not_valid') {
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const payload = {
      name: name,
      email: email,
      phone_number: phone_number,
      recipient_id: sessionId,
      ip_address: ip,
    };
    postWithoutToken('Create_LeadInformationAPI?company=' + companyDetails?.id, payload)
      .then((response) => {
        if (response.status === 201) {
          setFormData(initialFormValue);
          setShowForm(false);
          const formattedPrompt = `**Name:** ${formData.name}\n**Email:** ${formData.email}\n**Number:** ${formData.phone_number}`;
          handleChoice(e, formattedPrompt);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const fetchCalendlyLink = async () => {
    try {
      const response = await postWithToken('create_calendly_scheduling_link', apiTokenData, { session_id: sessionId });
      if (response.status === 200) {
        return response?.data;
      }
    } catch (error) {
      toast.error('Something went wrong');
      return null;
    }
  };

  function MessageComponent({ message }) {
    const lines = message.split('\n');

    return (
      <>
        {lines.map((line, index) => (
          <p key={index} className='m-0 outfit-regular font16'>
            {line}
          </p>
        ))}
      </>
    );
  }
  return (
    <>
      <div
        className={`chatbox-container ${openChatbox ? 'widgetOpen' : ''}`}
        style={{
          background: widgetDetails?.background_color?.includes('http') ? `url(${widgetDetails?.background_color})` : widgetDetails?.background_color,
          backgroundSize: 'cover',
          transition: '0.5s all',
          width: `${widgetDetails?.chatbot_slider_size}px`,
          transform: openChatbox ? 'translateX(0)' : `translateX(${Number(widgetDetails?.chatbot_slider_size) + 50}px)`,
        }}
      >
        <div className='chatbox-header flex-column justify-content-center'>
          <div
            className='close-arrow'
            style={{ background: widgetDetails?.client_bubble_color }}
            onClick={() => {
              setOpenChatbox(false);
              setDeleteConfirmPopup(false);
              setWelBubblePopup(false);
            }}
          >
            <MdOutlineKeyboardArrowRight />
          </div>

          {/* Add Three Dot Dropdown */}
          <div className='chatbox-dropdown-container'>
            <div className='chatbox-three-dots' onClick={toggleDropdown}>
              <BsThreeDotsVertical style={{ color: widgetDetails?.client_bubble_color || '#000000ff', fontSize: '20px' }} />
            </div>

            {isDropdownOpen && (
              <div className='chatbox-dropdown-menu'>
                <div className='dropdown-item' onClick={(e) => hanldeClearData(e)}>
                  <MdOutlineAddBox style={{ color: widgetDetails?.client_bubble_color, fontSize: '16px' }} />
                  <span className='outfit-regular'>Start a new chat</span>
                </div>
                <div
                  className='dropdown-item'
                  onClick={() => {
                    if (chatData?.length > 0) {
                      setIsDropdownOpen(false);
                      setDeleteConfirmPopup(true);
                    }
                  }}
                  style={{
                    cursor: chatData?.length === 0 ? 'not-allowed' : 'pointer',
                    opacity: chatData?.length === 0 ? 0.5 : 1,
                  }}
                >
                  <CgClose style={{ color: widgetDetails?.client_bubble_color, fontSize: '16px' }} />
                  <span className='outfit-regular'>End chat</span>
                </div>
              </div>
            )}
          </div>
          <div
            className='chatbox-header-icon'
            style={{
              maxWidth: widgetDetails?.header_logo_size ? `${widgetDetails.header_logo_size}px` : '200px',
              width: '100%',
              display: 'inline-block',
            }}
          >
            <img src={widgetDetails?.chatbot_logo || COMNIQ_LOGO} alt='chatbox-logo' className='w-100' style={{ objectFit: 'contain', display: 'block' }} />
          </div>
          {/* <div className='chatbox-header-text mt-2'>
            <p className='outfit-bold' style={{ color: widgetDetails?.heading_font_color, fontSize: `${widgetDetails?.heading_font_size}px` }}>
              {widgetDetails?.heading}
            </p>
          </div> */}

          {/* Overlay to close dropdown when clicking outside */}
          {isDropdownOpen && <div className='dropdown-overlay' onClick={() => setIsDropdownOpen(false)} />}
        </div>
        <div className='custom-hr m-0' style={{ borderTop: `2px solid ${widgetDetails?.client_bubble_color}` }}></div>
        <div className='chatbox-body'>
          <div className={`chatbox-body-box ${!hideLeadButtons && welcomeDetails?.lead_choice != null && 'pt-5 mb-0'}`}>
            <>
              {welcomeDetails?.welcome_msg !== '' && (
                <>
                  {welcomeDetails?.lead_status === true ? (
                    <div className='w-100'>
                      <div
                        className={`chatbot-welcome-body editdata-chatbox ${hideLeadButtons && welcomeDetails?.lead_choice != null ? 'p-0' : 'EditChatbot-withBoxShadow'}`}
                        style={{
                          background: hideLeadButtons && welcomeDetails?.lead_choice !== null ? 'initial' : widgetDetails?.inside_bubble_bg_color,
                          width: `${widgetDetails?.inside_bubble_width}px`,
                          height: hideLeadButtons && welcomeDetails?.lead_choice !== null ? '0px' : `${widgetDetails?.inside_bubble_height}px`,
                          margin: hideLeadButtons && welcomeDetails?.lead_choice !== null ? '0px' : '0 auto',
                        }}
                      >
                        {!hideLeadButtons && (
                          <>
                            {!showForm && (
                              <div
                                className='d-flex justify-content-center align-items-center chatbot-popup-icon'
                                style={{
                                  width: `${widgetDetails?.bubble_avatar_size}px`,
                                  height: `${widgetDetails?.bubble_avatar_size}px`,
                                  minWidth: `${widgetDetails?.bubble_avatar_size}px`,
                                  minHeight: `${widgetDetails?.bubble_avatar_size}px`,
                                  borderRadius: '50%',
                                  backgroundColor: widgetDetails?.inside_bubble_bg_color,
                                  position: 'absolute',
                                  top: 0,
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                }}
                              >
                                <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' style={{ width: '90%', height: 'auto', objectFit: 'cover' }} />
                              </div>
                            )}
                            <div className={`d-flex align-items-center ${showForm && 'mt-3'}`}>
                              {showForm && (
                                <div className='chatbox-user-icon me-3'>
                                  <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' />
                                </div>
                              )}
                              <div className={` ${showForm ? 'chatbox-user-replytext' : 'mt-4'}`} style={{ background: showForm && widgetDetails?.color }}>
                                <p
                                  className='m-0 outfit-bold text-center'
                                  style={{ color: widgetDetails?.inside_text_color_bubble, fontSize: `${widgetDetails?.inside_bubble_text_size}px` }}
                                >
                                  {welcomeDetails?.welcome_msg}
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                        {!hideLeadButtons && welcomeDetails?.lead_choice != null && (
                          <div className='d-flex flex-column align-items-center gap-3 w-100'>
                            {welcomeDetails?.lead_choice.map((choice, index) => (
                              <React.Fragment key={index}>
                                <button
                                  className='btn btn-submit-bubble outfit-regular font14'
                                  style={{
                                    marginTop: index === 0 ? '1rem' : '0',
                                    color: index === 0 ? widgetDetails?.inside_btn_primary_text : widgetDetails?.inside_btn_secondary_text,
                                    background: index === 0 ? widgetDetails?.inside_btn_primary_bg : widgetDetails?.inside_btn_secondary_bg,
                                    fontSize: index === 0 ? `${widgetDetails?.user_bubble_font_size}px` : `${widgetDetails?.agent_bubble_font_size}px`,
                                    // border: `2px solid ${widgetDetails?.client_bubble_color}`,
                                    width: `${widgetDetails?.inside_bubble_button_width}px`,
                                    height: `${widgetDetails?.inside_bubble_button_height}px`,
                                    borderRadius: '34px',
                                  }}
                                  onClick={
                                    index === 0
                                      ? (e) => handleChoice(e, choice)
                                      : (e) => {
                                          handleChoice(e, choice);
                                          setShowFormButton(true);
                                        }
                                  }
                                >
                                  {choice}
                                </button>
                                <style>
                                  {` 
                                   
                                   .hr-line::after {                     
                                     background-color: ${widgetDetails?.text_color};
                                   }
                                   .hr-line::before {                      
                                     background-color: ${widgetDetails?.text_color};
                                   }

                                   .chat-group-btn:hover {
                                     background-color: ${widgetDetails?.client_bubble_color};
                                     color: ${widgetDetails?.bubble_text_color}; 
}
                                 `}
                                </style>
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className='d-flex align-items-center mt-3'>
                      <div className='custom-chat-anstext' style={{ background: widgetDetails?.color }}>
                        <div className='chatbox-user-icon mb-2'>
                          <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' />
                        </div>
                        <p className='m-0' style={{ color: widgetDetails?.agent_bubble_text_color }}>
                          {welcomeDetails?.welcome_msg}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
              {chatData.length > 0 &&
                chatData?.map((obj, index) => {
                  return (
                    <>
                      <div className='mb-2' key={index}>
                        {obj.prmt && (
                          <div className='d-flex align-items-center justify-content-end mt-3'>
                            <div className='chatbox-user-quetext' style={{ background: widgetDetails?.client_bubble_color }}>
                              <p
                                className='outfit-regular m-0'
                                style={{ color: widgetDetails?.bubble_text_color, fontSize: `${widgetDetails?.user_bubble_font_size}px`, whiteSpace: 'pre-line' }}
                              >
                                {formatText(obj?.prmt)}
                              </p>
                            </div>
                          </div>
                        )}
                        <div>
                          {obj?.text && (
                            <div className='d-flex editdata-chatbox mt-3'>
                              <div className='d-flex align-items-center'>
                                <div className='chatbox-user-replytext' style={{ background: widgetDetails?.color }}>
                                  <div className='d-flex align-items-center mb-2'>
                                    <div className='chatbox-user-icon me-2'>
                                      <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' />
                                    </div>
                                    <span className='outfit-bold' style={{ color: widgetDetails?.agent_bubble_text_color }}>
                                      {widgetDetails?.bot_name}
                                    </span>
                                  </div>
                                  <p
                                    className='m-0'
                                    style={{ color: widgetDetails?.agent_bubble_text_color, whiteSpace: 'pre-line', fontSize: `${widgetDetails?.agent_bubble_font_size}px` }}
                                  >
                                    <Linkify
                                      componentDecorator={(decoratedHref, decoratedText, key) => (
                                        <a target='blank' href={decoratedHref} key={key}>
                                          {decoratedText}
                                        </a>
                                      )}
                                    >
                                      {formatText(obj?.text)}
                                    </Linkify>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              {loader && (
                <>
                  <div className='custom-chat-anstext d-inline-block mt-3' style={{ background: widgetDetails?.color, width: 'fit-content' }}>
                    <div className='d-flex align-items-center'>
                      <div className='widget-user-icon position-relative'>
                        <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' />
                      </div>
                      <ThreeDotLoader />
                      <style>
                        {` 
                        .dot-flashing
                        {
                          background-color: ${widgetDetails?.client_bubble_color};
                        }
                        .dot-flashing::before{
                          background-color: ${widgetDetails?.client_bubble_color};
                         }
                        .dot-flashing::after {
                          background-color: ${widgetDetails?.client_bubble_color};
                         }
                         @keyframes dot-flashing {
                          0% {
                            background-color: ${widgetDetails?.client_bubble_color};
                          }
                          50%,
                          100% {
                            background-color: #5f5f5f1c;
                          }
                        }
                        
                        `}
                      </style>
                    </div>
                  </div>
                </>
              )}

              {showRecommendation && (
                <>
                  <div className='chat-group d-flex flex-wrap align-items-center gap-2'>
                    {showRecommendation?.map((recommendation, index) => (
                      <button
                        key={index}
                        className='btn chat-group-btn'
                        style={{
                          background: `${widgetDetails?.color}`,
                          color: `${widgetDetails?.agent_bubble_text_color}`,
                          border: `3px solid ${widgetDetails?.client_bubble_color}`,
                          fontSize: `${widgetDetails?.agent_bubble_font_size}px`,
                          width: widgetDetails?.chatbot_slider_size <= 360 ? '100%' : 'unset',
                        }}
                        onClick={(e) => {
                          handleChoice(e, recommendation?.answer);
                          setShowRecommendation(null);
                        }}
                      >
                        {recommendation?.answer}
                      </button>
                    ))}
                  </div>
                  <style>
                    {`
                     .chat-group-btn:hover {
                        background: ${widgetDetails?.client_bubble_color} !important;
                        color: ${widgetDetails?.bubble_text_color} !important; 
                      }
                    `}
                  </style>
                </>
              )}

              {showForm && (
                <div className='user-box-wrapper position-relative' style={{ background: widgetDetails?.color }}>
                  <div className='user-box' style={{ border: `3px solid ${widgetDetails?.color}` }}>
                    <div className='user-box-img'>
                      <div
                        className='widget-user-icon'
                        style={{
                          width: '40px',
                          height: '40px',
                          minWidth: '40px',
                          minHeight: '40px',
                        }}
                      >
                        <img src={widgetDetails?.chatbot_avtar || SIDEBAR_BOX_IMG} alt='chatbot-icon' />
                      </div>
                    </div>

                    <form id='form' onSubmit={handleFormSubmit}>
                      <div className='mb-3'>
                        <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
                          Name
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          name='name'
                          id='name'
                          required
                          autoComplete='off'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'
                          placeholder='Enter your name'
                          value={name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          style={{ color: '#000000' }}
                        />
                      </div>
                      <div className='mb-3'>
                        <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
                          Email
                        </label>
                        <input
                          type='email'
                          className='form-control'
                          name='email'
                          required
                          autoComplete='off'
                          placeholder='Enter your email'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'
                          value={email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          style={{ color: '#000000' }}
                        />
                      </div>
                      <div className='mb-4'>
                        <label className='outfit-medium' style={{ color: widgetDetails?.agent_bubble_text_color }}>
                          Phone
                        </label>
                        <input
                          type='number'
                          className='form-control'
                          name='phone_number'
                          required
                          autoComplete='off'
                          placeholder='Enter your number'
                          maxLength='10'
                          value={phone_number}
                          onChange={(e) => {
                            if (e.target.value.length <= 10) {
                              setFormData({ ...formData, phone_number: e.target.value });
                            }
                          }}
                          style={{ color: '#000000' }}
                        />
                      </div>

                      <input
                        id='submit'
                        type='submit'
                        disabled={name === '' || phone_number === '' || email === '' || isButtonDisabled}
                        style={{
                          opacity: name === '' || phone_number === '' || email === '' ? 0.3 : 1,
                          cursor: name === '' || phone_number === '' || email === '' ? 'not-allowed' : 'pointer',
                          background: widgetDetails?.client_bubble_color,
                          color: widgetDetails?.bubble_text_color,
                        }}
                      />
                    </form>
                  </div>
                </div>
              )}
              {showCalendar.show && <CalendlyEmbed url={showCalendar.link} />}
              <ScrollToBottom scrollChatData={chatData} scrollLoader={loader} showForm={showForm} showRecommendation={showRecommendation} />
            </>
          </div>
        </div>

        <div className='p-3'>
          {(hideLeadButtons && hideLeadClosingButtons) || !welcomeDetails?.lead_status ? (
            <>
              {showFormButton && !isLeadButtonHide && (
                <div className='d-flex flex-column align-items-center justify-content-end mb-2' style={{ gap: '0.5rem' }}>
                  {/* <button
                    className='btn outfit-regular font14 w-100'
                    onClick={(e) => {
                      handleChoice(e, welcomeDetails?.create_lead_choice);
                      setIsLeadButtonHide(true);
                    }}
                    style={{
                      color: widgetDetails?.bubble_text_color,
                      background: widgetDetails?.client_bubble_color,
                      border: `2px solid ${widgetDetails?.client_bubble_color}`,
                      height: '40px',
                      borderRadius: '34px',
                    }}
                    disabled={isButtonDisabled}
                  >
                    {welcomeDetails?.create_lead_choice}
                  </button> */}
                  <button
                    className='btn outfit-regular font14 w-100'
                    onClick={async () => {
                      setIsLeadButtonHide(true);
                      if (welcomeDetails?.lead_form) {
                        setShowForm(true);
                      } else {
                        const calendlyLink = await fetchCalendlyLink();
                        if (calendlyLink) {
                          setShowCalendar({ show: true, link: calendlyLink });
                        }
                      }
                    }}
                    style={{
                      backgroundColor: widgetDetails?.color,
                      color: widgetDetails?.agent_bubble_text_color,
                      borderRadius: '34px',
                      border: 'none',
                      height: '40px',
                    }}
                    disabled={isButtonDisabled}
                  >
                    {welcomeDetails?.generate_lead_choice || 'Generate Lead'}
                  </button>
                </div>
              )}

              <form className='chatbox-group d-flex justify-content-between align-items-center' style={{ border: `1.5px solid ${widgetDetails?.chat_input_bgcolor}` }}>
                {/* <div className='chatbox-input-group'>
                  <button
                    type='button'
                    className='btn refresh-btn'
                    disabled={customDisabled}
                    style={{ backgroundColor: widgetDetails?.chat_input_bgcolor }}
                    onClick={() => setDeleteConfirmPopup(true)}
                  >
                    <BiTrash className='icon-refresh' style={{ color: widgetDetails?.chat_input_icon_color }} />
                  </button>
                </div> */}
                <input
                  type='text'
                  className='form-control chat-input'
                  placeholder='Type your message...'
                  name='message'
                  value={values}
                  onChange={(e) => setValues(e.target.value)}
                  disabled={showForm || showCalendar.show}
                  style={{ color: widgetDetails?.chat_input_font_color, fontSize: `${widgetDetails?.chat_input_fontsize}px` }}
                  autoComplete='off'
                />
                <style>
                  {` 
                    .chatbox-group input::placeholder { 
                        color: ${widgetDetails?.chat_input_font_color}; 
                        font-size: ${widgetDetails?.chat_input_fontsize}px;
                    }
                  `}
                </style>
                <div className='chatbox-input-group'>
                  <button
                    type='submit'
                    className='btn send-btn'
                    disabled={customDisabled || showForm || showCalendar.show}
                    style={{ backgroundColor: widgetDetails?.chat_input_bgcolor }}
                    onClick={handleSubmit}
                  >
                    <IoSend className='icon-send ms-1' style={{ color: widgetDetails?.chat_input_icon_color }} />
                  </button>
                </div>
              </form>
            </>
          ) : null}
        </div>
        <div className={`custom-chat-footer ${showPrivacy && welcomeDetails?.lead_status ? 'p-3' : ''}`}>
          {showPrivacy && welcomeDetails?.lead_status && (
            <div className='chat-privacy-text d-flex justify-content-between align-items-center' style={{ background: widgetDetails?.inside_btn_secondary_bg }}>
              <p className='mb-0' style={{ color: widgetDetails?.inside_btn_secondary_text }}>
                By chatting, you agree to our{' '}
                <a href='https://www.comniqai.com/privacy-policy' target='_blank' rel='noopener noreferrer' className='privacy-link outfit-medium'>
                  Privacy Policy
                </a>
                .
              </p>
              <button type='button' className='privacy-close-btn' onClick={() => setShowPrivacy(false)}>
                <X size={16} style={{ color: widgetDetails?.inside_btn_secondary_text }} />
              </button>
            </div>
          )}
          {welcomeDetails?.is_powered_by_visible && (
            <a href='https://www.comniqai.com' target='_blank' rel='noopener noreferrer' className='d-flex align-items-center'>
              <img src={SIDEBAR_BOX_IMG} alt='ComniqAI Logo' className='footer-logo' title='ComniqAI' />
              <h3 className='outfit-regular mb-0' style={{ color: widgetDetails?.text_color, fontSize: `${widgetDetails?.windo_font_size}px` }}>
                Powered by
              </h3>
              <span className='outfit-bold lead-summary-color mb-0' style={{ fontSize: `${widgetDetails?.windo_font_size}px` }}>
                ComniqAI
              </span>
            </a>
          )}
        </div>

        {deleteConfirmPopup && (
          <div className='delete-confirmation-popup'>
            <div
              className='confirmation-box'
              style={{
                background: widgetDetails?.background_color?.includes('http') ? `url(${widgetDetails?.background_color})` : widgetDetails?.background_color,
                backgroundSize: 'cover',
              }}
            >
              <div className='logo-wrapper' style={{ maxWidth: `${widgetDetails?.header_logo_size}px`, width: '100%', maxHeight: 'none', display: 'inline-block' }}>
                <img src={widgetDetails?.chatbot_logo || COMNIQ_LOGO} alt='chatbot-icon' className='chatbot-logo w-100' style={{ objectFit: 'contain', display: 'block' }} />
              </div>
              <p className='delete-confirmation-text' style={{ color: widgetDetails?.text_color }}>
                Are you sure you want to permanently delete and reset the chat?
              </p>
              <div className='button-group'>
                <button
                  className='btn-confirm'
                  style={{ background: widgetDetails?.client_bubble_color, color: widgetDetails?.bubble_text_color }}
                  onClick={(e) => hanldeClearData(e)}
                >
                  Yes!
                </button>
                <button
                  className='btn-cancel'
                  style={{
                    backgroundColor: widgetDetails?.color,
                    color: widgetDetails?.agent_bubble_text_color,
                    border: `2px solid ${widgetDetails?.client_bubble_color}`,
                  }}
                  onClick={() => setDeleteConfirmPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(AIPreview);
